/**
 * The session this tab is in, for work that outlives it: a change started in
 * one session must not write into the next one's cache when its answer lands
 * late (Codex on #298). `forgetSession` ends it: the generation moves on and
 * the requests started in it are aborted.
 */
let generation = 0;
let controller = new AbortController();

/** The session as a change starts: its generation, and a signal its end aborts. */
export type SessionMark = { generation: number; signal: AbortSignal };

export function sessionMark(): SessionMark {
  return { generation, signal: controller.signal };
}

/** Whether the session a change started in is still this tab's. */
export function inSession(mark: SessionMark | undefined): boolean {
  return mark?.generation === generation;
}

/** Ends the session: its marks go stale, and its requests are aborted. */
export function endSession() {
  generation += 1;
  controller.abort();
  controller = new AbortController();
}
